// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1f8d46ca","977":"97c88509"}[chunkId] + ".chunk.js";
};